import React from "react";
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import { QueuedJob_info$key } from "./__generated__/QueuedJob_info.graphql";

interface QueuedJobProps {
  info: QueuedJob_info$key;
}

function QueuedJob(props: QueuedJobProps) {
  const theme = useTheme();

  let info = useFragment(
    graphql`
      fragment QueuedJob_info on GithubWorkflowJobInfo {
        jobId
        repository
        name
        status
        image
        externalUrl
      }
    `,
    props.info,
  );

  return (
    <ListItem
      disableGutters
      id={info.jobId}
      secondaryAction={
        <IconButton
          edge="end"
          aria-label="delete"
          onClick={() => window.open(info.externalUrl, "_blank")}
        >
          <OpenInNewIcon />
        </IconButton>
      }
    >
      <ListItemIcon>
        <Avatar sx={{ bgcolor: theme.palette.warning.light }}>
          <AppleIcon />
        </Avatar>
      </ListItemIcon>
      <ListItemText
        primary={`"${info.name}" job in ${info.repository} repostiory`}
        secondary={info.image}
      />
    </ListItem>
  );
}

export default QueuedJob;
